import { IconType, SvgIcon } from './SvgIcon';

export const MaximizeIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 26 26">
    <rect width="26" height="26" rx="13" fill="#2540F5" />
    <path
      d="M7.75 11.25L7.75 7.75H11.25"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.25 14.75V18.25H14.75"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 7.74967L11.8333 11.833"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2503 18.25L14.167 14.1667"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

MaximizeIcon.displayName = 'MaximizeIcon';
